/* lua.js generated code undefined */
 // 关卡区间标签
let Base = unpack(require("clover/logic/userTagData/UserTagBase"))[0]
// let TagConfig = require("clover/config/userTag/LevelAreaTagConfig")
let Tag = xClass("LevelAreaTag", Base)
Tag.prototype.init = function () {
    let self = this
    self.config = table()
}
Tag.prototype.refresh = function (data) {
    let self = this
    // donothing 
}
Tag.prototype.getTag = function () {
    // let self = this
    // let topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    // for (let k in TagConfig) {
    //     let v = TagConfig[k]
    //     if ($null(v)) continue
    //     if (topLevel >= v.min && topLevel <= v.max) {
    //         return k
    //     }
    // }
    return 0
}
module.exports = Tag
